import React, { useState } from 'react';
import './PillToggle.css';

export default function PillToggle({ onChange, labels = [], initialValue = 0 }) {
  const [selectedIndex, setSelectedIndex] = useState(initialValue);

  const handleToggle = (index) => {
    setSelectedIndex(index);
    if (onChange) onChange(index);
  };

  const count = labels.length;

  return (
    <div className="pill-toggle-container">
      <button
        type="button"
        className={`pill-track${count > 1 ? ' pill-with-labels' : ''}`}
        style={{ '--pill-index': selectedIndex, '--pill-count': count }}
        aria-label={labels[selectedIndex] || 'Toggle'}
      >
        <div className="pill-thumb" />
        {labels.map((label, i) => (
          <span key={i} onClick={() => handleToggle(i)} className={`pill-label ${i === selectedIndex ? 'pill-label-active' : 'pill-label-inactive'}`}>
            {label}
          </span>
        ))}
      </button>
    </div>
  );
}
